module.exports = __webpack_public_path__ + "img/stm-b.1902b651.png";